import * as React from 'react';
import {connect} from 'react-redux';

import {updateSlideElement} from 'client/actions/slideShowEditor';
import {
	ISlideElement,
	SlideElementTelegramMethodShowEnum,
	SlideElementTelegramMethodShowEnumDisplay,
} from 'shared/collections/SlideElements';
import {RootState} from 'client/store/root-reducer';
import ElementSettingsWrapper from 'client/components/common/ElementSettingsWrapper';
import EditorCheckbox from 'client/components/editor/formFields/EditorCheckbox';
import EditorDelimiter from '../formFields/EditorDelimiter';
import BgColorField from '../settingsFields/BgColorField';
import BgImageField from '../settingsFields/BgImageField';
import OpacityField from '../settingsFields/OpacityField';
import PermanentElementField from '../settingsFields/PermanentElementField';
import ShowPostsField from '../settingsFields/ShowPostsField';
import EditorTextInput from '../formFields/EditorTextInput';
import EditorActionButtonsCommon from '../formFields/EditorActionButtonsCommon';
import EditorActionButtonsSocial from '../formFields/EditorActionButtonsSocial';
import EditorSelect from 'client/components/editor/formFields/EditorSelect';
import RotateAngleField from 'client/components/editor/settingsFields/RotateAngleField';
import {LL} from 'shared/localization';

interface ITelegramElementSettingsProps {
	slideshowId: string;
	element: ISlideElement;
	updateSlideElement: typeof updateSlideElement;
}

class TelegramElementSettings extends React.PureComponent<ITelegramElementSettingsProps> {
	handleTelegramIdChannelChange = (value?: string) => {
		const {element} = this.props;

		this.props.updateSlideElement(element, {telegramChannelId: value});
	};

	handleTelegramDiscussionIdChange = (value?: string) => {
		const {element} = this.props;

		this.props.updateSlideElement(element, {telegramDiscussionId: value});
	};

	handleTelegramPostCountChange = (value?: number) => {
		const {element} = this.props;

		this.props.updateSlideElement(element, {
			telegramPostCount: value,
		});
	};

	handleMethodShowChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const {element} = this.props;

		this.props.updateSlideElement(element, {
			telegramMethodShow: event.target.value as SlideElementTelegramMethodShowEnum,
		});
	};

	handleChangeHideText = (e: React.ChangeEvent<HTMLInputElement>) => {
		const {checked} = e.target;
		const {element} = this.props;
		this.props.updateSlideElement(element, {telegramHideText: checked});
	};

	handleChangeHideImage = (e: React.ChangeEvent<HTMLInputElement>) => {
		const {checked} = e.target;
		const {element} = this.props;

		this.props.updateSlideElement(element, {telegramHideImage: checked});
	};

	render() {
		const {element} = this.props;

		return (
			<ElementSettingsWrapper elementId={element._id}>
				<EditorSelect
					label={LL('editor.element.output')}
					options={[
						{
							label: SlideElementTelegramMethodShowEnumDisplay.CHANNEL,
							value: SlideElementTelegramMethodShowEnum.CHANNEL,
						},
						{
							label: SlideElementTelegramMethodShowEnumDisplay.CHAT,
							value: SlideElementTelegramMethodShowEnum.CHAT,
						},
					]}
					onChange={this.handleMethodShowChange}
					value={element.telegramMethodShow || SlideElementTelegramMethodShowEnum.CHANNEL}
				/>

				{element.telegramMethodShow === 'CHAT' ? (
					<EditorTextInput
						label="ID Телеграм чата"
						tooltip={
							<div>
								Вводится в формате 'название группы/айди чата' - например:
								azurapark_residence/1
								<br />
								Как получить ID дискуссии
								<br />
								1 Открываем дискуссию в телеграмме
								<br />
								2 Открываем чат дискуссии
								<br />3 Открываем описание там в разделе информация будет ссылка
								Например, https://t.me/azurapark_residence/10413 значит нам нужно
								указать azurapark_residence/10413
							</div>
						}
						value={element.telegramDiscussionId}
						onChange={this.handleTelegramDiscussionIdChange}
					/>
				) : (
					<EditorTextInput
						label={LL('editor.element.telegramId')}
						value={element.telegramChannelId}
						onChange={this.handleTelegramIdChannelChange}
					/>
				)}

				{element.telegramMethodShow === 'CHANNEL' && (
					<EditorCheckbox
						label={LL('editor.element.hideText')}
						tooltip={LL('editor.element.hideText.tooltip')}
						value="constElement"
						checked={element.telegramHideText}
						onChange={this.handleChangeHideText}
					/>
				)}

				{element.telegramMethodShow === 'CHANNEL' && (
					<EditorCheckbox
						label={LL('editor.element.hidePictures')}
						tooltip={LL('editor.element.hidePictures.tooltip')}
						value="constElement"
						checked={element.telegramHideImage}
						onChange={this.handleChangeHideImage}
					/>
				)}

				<EditorTextInput
					label={LL('editor.element.numberOfMessages')}
					tooltip={LL('editor.element.numberOfMessages.tooltip')}
					value={element.telegramPostCount}
					onChange={this.handleTelegramPostCountChange}
					type="number"
					inputProps={{min: 1, step: 1}}
				/>

				{element.telegramMethodShow === 'CHANNEL' && <ShowPostsField element={element} />}
				{element.telegramMethodShow === 'CHANNEL' && <BgColorField element={element} />}
				{element.telegramMethodShow === 'CHANNEL' && <BgImageField element={element} />}
				<RotateAngleField element={element} />
				<OpacityField element={element} />
				<PermanentElementField element={element} />

				<EditorDelimiter />

				<EditorActionButtonsCommon element={element} />
				<EditorActionButtonsSocial slideElementId={element._id} />
			</ElementSettingsWrapper>
		);
	}
}

export default connect(
	(state: RootState) => ({
		slideshowId: state.slideShowEditor.slideshowId,
	}),
	{updateSlideElement},
)(TelegramElementSettings);
